import { Grid } from "@mui/material";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { tokens } from "styles/Tokens";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (args: any) => void;
}

const UpdateStatusConfirmDialog = (props: Props) => {
  const translate = useTranslate();
  const { open, onClose, onConfirm } = props;

  return (
    <Grid
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {" "}
      <DialogFormation
        openDialog={open}
        handleClose={onClose}
        title="Are you sure you want to update the status of the action?"
        actionConfig={
          <div className="modal-config-wrapper">
            <Button label="Proceed" variant="secondary" onClick={onConfirm} />
            <Button label="Cancel" onClick={onClose} />
          </div>
        }
      >
        <Typography variant="body2" color={tokens.Text.General.PrimaryBody} sx={{ textAlign: "center" }}>
          {translate("myPlan.changeAction.status.popup")}
        </Typography>
      </DialogFormation>
    </Grid>
  );
};

export default UpdateStatusConfirmDialog;
